module.exports = __webpack_public_path__ + "img/chamor_yes.cd3c5d61.png";